module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/icon_link-df577e07721099fa8637e25da379ea84.svg";